import { render, staticRenderFns } from "./managementTeam.vue?vue&type=template&id=7bfef20c&scoped=true"
import script from "./managementTeam.vue?vue&type=script&lang=js"
export * from "./managementTeam.vue?vue&type=script&lang=js"
import style0 from "./managementTeam.vue?vue&type=style&index=0&id=7bfef20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfef20c",
  null
  
)

export default component.exports